import { create } from 'zustand'
import { inventoryStorageLocType, StoredActivityType } from 'types/event/events'
import { EventStep5Payload } from 'types/event/eventStep5'

const eventCreationStore = (set: any) => ({
  eventTypeModalVisible: false,
  setEventTypeModalVisible: (state: boolean) =>
    set(() => ({ eventTypeModalVisible: state })),

  stepCounter: 0,
  setStepCounter: (state: number) => set(() => ({ stepCounter: state })),

  selectedDate: undefined,
  setSelectedDate: (state: Date) => set(() => ({ selectedDate: state })),

  activity: undefined,
  setActivity: (state: StoredActivityType) => set(() => ({ activity: state })),

  customActivity: undefined,
  setCustomActivity: (state: any) => set(() => ({ customActivity: state })),

  storageLocation: null,
  setStorageLocation: (state: inventoryStorageLocType) =>
    set(() => ({ storageLocation: state })),
  duplicateModalOpen: false,
  setDuplicateModalOpen: (state: boolean) =>
    set(() => ({ duplicateModalOpen: state })),

  eventData: null,
  setEventData: (state: any) => set(() => ({ eventData: state })),
  requiredDetails: null,
  setRequiredDetails: (state: any) => set(() => ({ requiredDetails: state })),
  step3Payload: {
    numOfStaff: 1,
    estimatedUnitStaffSalary: { min: 0, max: 0 },
    totalStaffSalary: { min: 0, max: 0 },
    venuePrice: { min: 0, max: 0 },
    estimatedTotalPrice: { min: 0, max: 0 },
    estimatedAvgTicketPrice: { min: 0, max: 0 },
  },

  setStep3Payload: (state: any) =>
    set((currentState: any) => ({
      step3Payload: { ...currentState.step3Payload, ...state },
    })),

  step5Payload: {},
  setStep5Payload: (state: EventStep5Payload) =>
    set(() => ({ step5Payload: state })),

  //new approach
  riskLevel: undefined,
  setRiskLevel: (state: 'low' | 'medium' | 'high') =>
    set(() => ({ riskLevel: state })),
  agreements: [],
  setAgreements: (state: string[]) => set(() => ({ agreements: state })),
  itemsToBring: [],
  setItemsToBring: (state: string[]) => set(() => ({ itemsToBring: state })),
  selectedFaqIds: [],
  setSelectedFaqIds: (state: string[]) =>
    set(() => ({ selectedFaqIds: state })),
  selectedRequiredDocumentIds: [],
  setSelectedRequiredDocumentIds: (state: string[]) =>
    set(() => ({ selectedRequiredDocumentIds: state })),

  // step 6
  documentsApprovalRequired: false,
  setDocumentsApprovalRequired: (state: boolean) =>
    set(() => ({ documentsApprovalRequired: state })),
  coverPhotoIds: [],
  setCoverPhotoIds: (state: string[]) => set(() => ({ coverPhotoIds: state })),
  description: undefined,
  setDescription: (state: string) => set(() => ({ description: state })),
})

export const creationEventStore = create(eventCreationStore)
